import { Button, Collapse, List } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import { pickAFileSliceDispatch,  serviceQuestionBrandModalSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import ServiceQuestionBrandModal from ".././ServiceQuestionBrandModal/ServiceQuestionBrandModal";

const ServiceQuestionBrandViewer = () => {
    const dispatch = useDispatch();
    const { CreateContentsFromStates } = ReduxHelpers();
    const currentBrands = useSelector((state: any) => state.pickAFile.brandList);
    const currentServices = useSelector((state: any) => state.pickAFile.serviceList);
    const currentQuestions = useSelector((state: any) => state.pickAFile.questions);
    const currentServiceQuestionBrand = useSelector((state: any) => state.pickAFile.serviceBrandQuestions);
    const open = useSelector((state: any) => state.serviceQuestionBrandModal.open);

    const serviceBrands = [];

    currentServices.forEach(s => {
        currentBrands.forEach(b => {
            serviceBrands.push(
                {
                    serviceId: s.serviceId, 
                    brandId: b.brandId,
                    serviceName: s.serviceName,
                    brandName: b.brandName
                });
        });
    });

    const getCountForServiceBrand = (serviceBrand) => {
        return currentServiceQuestionBrand.filter(sb => sb.assistanceServiceId == serviceBrand.serviceId && sb.brandId == serviceBrand.brandId).length;
    }

    const getQuestionsForServiceBrand = (serviceBrand) => {
        const questionIds = currentServiceQuestionBrand
            .filter(sb => sb.assistanceServiceId === serviceBrand.serviceId && sb.brandId === serviceBrand.brandId).map(q => q.questionId);
        return currentQuestions.filter(q => questionIds.includes(q.questionId));
    }

    const removeQuestionFromServiceBrand = (serviceBrand, questionId) => {
        const filteredServices = currentServiceQuestionBrand.filter(sb =>
            sb.assistanceServiceId !== serviceBrand.serviceId ||
            sb.brandId !== serviceBrand.brandId ||
            sb.questionId !== questionId);

        dispatch({ type: pickAFileSliceDispatch.setServiceBrandQuestions, payload: filteredServices });
        CreateContentsFromStates({ serviceBrandQuestions: filteredServices });
    }

    const handleClick = (value, index) => {
        if (!open) {
            dispatch({ type: serviceQuestionBrandModalSliceDispatch.setBrandId, payload: value.brandId });
            dispatch({ type: serviceQuestionBrandModalSliceDispatch.setServiceId, payload: value.serviceId });
        }
    }

    const allServicesQuestions =
        <List>
            {
                Object.entries(serviceBrands).map(([key, value]) => {

                    const ListOfServices = (
                        <List
                            dataSource={getQuestionsForServiceBrand(value).sort((a, b) => a.questionId > b.questionId ? 1 : -1)}
                            renderItem={(question: any, index: number) => (
                                <div>
                                    <List.Item key={index}>
                                        <div>
                                            <Button id={String(index)}
                                                data-service={value.serviceId}
                                                data-brand={value.brandId}
                                                onClick={() => removeQuestionFromServiceBrand(value, question.questionId)}>Delete</Button>
                                            {question.dataKey}
                                        </div>
                                    </List.Item>
                                </div>
                            )}
                        />
                    );

                    const header = 
                        <div>
                            <ServiceQuestionBrandModal
                                caption={"Add Question(s) to Service/Brand " + value.serviceId + "/" + value.brandId} />
                            {value.serviceName} / {value.brandName} - {getCountForServiceBrand(value)}
                        </div>

                    return (
                        <List>
                            <Collapse
                                style={{ width: '100%' }}
                            >
                                <Collapse.Panel key={key} header={header} style={{ width: '100%' }}>
                                    {ListOfServices}
                                </Collapse.Panel>
                            </Collapse>
                        </List>
                    )
                })
            }
        </List>
    return <div>{allServicesQuestions}</div>
}

export default ServiceQuestionBrandViewer;